import React from 'react';
import Tickets from './index';
import ErrorBoundary from '../../../components/ErrorBoundary';

const HelpButton = React.lazy(() => import('../../../components/HelpButton'));
const TicketsCustomizedStatusList = React.lazy(() =>
  import('./TicketsCustomizedStatusList')
);
const TicketsCustomizedStatusPage = () => {
  return (
    <Tickets>
      <ErrorBoundary>
        <React.Suspense fallback={<div />}>
          <>
            <div className="text-right mb-2">
              <HelpButton fileName="tickets-customized-status" />
            </div>
            <TicketsCustomizedStatusList />
          </>
        </React.Suspense>
      </ErrorBoundary>
    </Tickets>
  );
};

export default TicketsCustomizedStatusPage;
